import { useEffect, useState } from 'react';
import apis from '../utils/apis';
import httpAction from '../utils/httpAction';

const defaultSettings = {
  siteName: 'RealCity',
  siteTagline: 'High-Rise & Investment',
  logoText: 'RC',
  footerDescription: '',
  footerQuickLinks: [],
  footerServiceLinks: [],
  partners: [],
  partnersTitle: 'Companies & Developers We Work With',
  partnersDescription: '',
  contactEmail: '',
  contactPhone: '',
  officeAddress: '',
  officeHours: '',
  facebookLink: '',
  instagramLink: '',
  linkedinLink: '',
  youtubeLink: '',
  whatsappNumber: '',
  googleMapLink: '',
  officeMapImage: '',
  contactHeroTitle: '',
  contactHeroDescription: '',
  contactFormTitle: '',
  contactFormDescription: '',
  aboutTitle: '',
  aboutDescription: '',
  aboutHeroImage: '',
  aboutStoryKicker: 'About Us',
  aboutStoryTitle: '',
  aboutStoryTextOne: '',
  aboutStoryTextTwo: '',
  aboutHighlightTitle: '',
  aboutHighlightText: '',
  aboutValues: [],
  aboutTimeline: [],
  aboutStats: [],
  ceoSectionKicker: 'Leadership',
  ceoName: '',
  ceoRole: '',
  ceoImage: '',
  ceoBioOne: '',
  ceoBioTwo: '',
  ceoQuote: '',
};

export default function useSiteSettings() {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  const loadSettings = async () => {
    setLoading(true);
    const result = await httpAction({ url: apis().publicSettings, silent: true });
    if (result?.status && result?.settings) {
      setSettings({ ...defaultSettings, ...result.settings });
    }
    setLoading(false);
  };

  useEffect(() => { loadSettings(); }, []);

  return { settings, loading, reloadSettings: loadSettings, setSettings };
}
